import styled, { useTheme } from 'styled-components';
import { Heading2Text } from '../../../../components/Texts';
import ColorizedSpan from '../../../../components/Colorized';
import GiftCardsScroll from './GiftCardsScroll';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import { useEffect, useRef, useState } from 'react';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  min-height: 750px;
  gap: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: unset;
    overflow: hidden;
    padding-top: 25px;
    padding-bottom: 25px;
  }
`;

const BackgroundColor = styled.div`
  background-color: ${({ theme }) => theme.primary.background};
  padding: 40px 0px;
  position: absolute;
  width: 100%;
  left: 0px;
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.title};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 0px;
  }
`;

const MostPopular = () => {
  const theme = useTheme();
  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState(undefined);

  useEffect(() => {
    const updateHeight = () => {
      if (backgroundRef.current) {
        setSiblingHeight(backgroundRef.current.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <BackgroundColor ref={backgroundRef}>
        <Container>
          <TitleContainer>
            <Heading2Text style={{ color: theme.text.title }}>
              Trusted by <ColorizedSpan>thousands</ColorizedSpan>
            </Heading2Text>
            <SubTitle style={{ color: theme.text.regular }}>
              See what our users have to say.
            </SubTitle>
          </TitleContainer>
          <GiftCardsScroll />
        </Container>
      </BackgroundColor>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default MostPopular;
